// #standard page 
import React, { Component } from 'react';

//#table
import GenericTable from '../../components/GenericTable';
import { currencyFormat } from '../../helpers/formatter';

//#form
import { Card, CardBody } from 'reactstrap';

//#other
import { fetchJSON } from '../../helpers/api';


const columns = [
    {
        dataField: 'fundNo',
        hidden: true,
    },
    {
        dataField: 'description',
        text: 'Description',
    },
    {
        dataField: 'serialNo',
        text: 'Serial No.',
    },
    {
        dataField: 'note',
        text: 'Note',
    },
    {
        dataField: 'hoursCycles',
        text: 'Hours/Cycles',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
    },
    {
        dataField: 'billingBasis',
        text: 'Billing Basis',
    },
    {
        dataField: 'rate',
        text: 'Billed Rate',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    },
    {
        dataField: 'billAmount',
        text: 'Amount Due',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    },
    {
        dataField: 'adjustmentAmount',
        text: 'Adjustment',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    },        
    {
        dataField: 'totalAmount',
        text: 'Total Due',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    },
];

const defaultSorted = [
    {
        dataField: 'fundNo',
        order: 'asc',
    },
];



class SuppRentDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
        };
    }

    componentDidMount = () => {
        this.loadSuppRentInvoiceDetails(this.props.leaseNo, this.props.invoiceNo);
    };

    async loadSuppRentInvoiceDetails(leaseNo, invoiceNo) {
        let url = `/portal/LeaseAccount/GetSuppRentInvoiceDetails?leaseNo=${leaseNo}&invoiceNo=${invoiceNo}`;
        let response = await fetchJSON(url);
        this.setState({
            data: response.data,
            loading: response.loading
        });
    }

    render() {
        return (
            <React.Fragment>
                <Card className="expand-row">
                    <CardBody>
                        <GenericTable
                            columns={columns}
                            data={this.state.data}
                            keyField='fundNo'
                            defaultSorted={defaultSorted}
                            loading={this.state.loading}
                            noSearch
                            noPagination
                        />
                        <br />
                        <span className="float-right"><small><em>Billing Basis: B - Block Hours, F - Flight Hours, C - Cycles, D - Days, FM - Fixed Monthly, M - Minimum Hours, X - Maximum Hours</em></small></span>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
};


export default SuppRentDetails;